import "./ContentPageSkeleton.css";

function Skeleton({ className = "" }) {
    return (
        <div className={`skeleton ${className}`} />
    );
}

export default function ContentPageSkeleton() {

    return (
        <article
            className="content-detail-skeleton"
            dir="rtl"
        >

            <div className="content-detail-skeleton__container">

                {/* ==============================
                    TITLE IMAGE
                ============================== */}

                <Skeleton className="content-skeleton__title-image" />


                {/* ==============================
                    TITLE
                ============================== */}

                <div className="content-skeleton__title">

                    <Skeleton />
                    <Skeleton className="short" />

                </div>


                {/* ==============================
                    CONTENT
                ============================== */}

                <div className="content-skeleton__content">

                    {/* Paragraph 1 */}
                    <div className="skeleton-paragraph">

                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton className="medium" />

                    </div>


                    {/* Heading */}
                    <Skeleton className="skeleton-heading" />


                    {/* Paragraph 2 */}
                    <div className="skeleton-paragraph">

                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton className="short" />

                    </div>


                    {/* Image / content block */}
                    <Skeleton className="skeleton-content-image" />


                    {/* Paragraph 3 */}
                    <div className="skeleton-paragraph">

                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton className="medium" />

                    </div>


                    {/* List */}
                    <div className="skeleton-list">

                        <div>
                            <Skeleton className="list-bullet" />
                            <Skeleton className="list-line" />
                        </div>

                        <div>
                            <Skeleton className="list-bullet" />
                            <Skeleton className="list-line" />
                        </div>

                        <div>
                            <Skeleton className="list-bullet" />
                            <Skeleton className="list-line" />
                        </div>

                        <div>
                            <Skeleton className="list-bullet" />
                            <Skeleton className="list-line short" />
                        </div>

                    </div>


                    {/* Final paragraph */}
                    <div className="skeleton-paragraph">

                        <Skeleton />
                        <Skeleton />
                        <Skeleton className="short" />

                    </div>

                </div>

            </div>

        </article>
    );
}